// context/WhiteLabelContext.tsx
import { createContext, useContext } from "react";
import { NavItemBaseProps } from "src/layouts/main/nav/types";

export type WhiteLabelConfig = {
  hideHeader?: boolean;
  hideFooter?: boolean;
  headerLogo?: string;
  hideHeaderMenu?: boolean;
  headerMenuItems?: NavItemBaseProps[];
  primaryColor?: string;
  backgroundColor?: string;
  buttonStyle?: "rounded" | "square";
};

const defaultConfig: WhiteLabelConfig = {
  hideHeader: false,
  hideFooter: false,
};

export const WhiteLabelContext = createContext<WhiteLabelConfig>(defaultConfig);

export const useWhiteLabel = () => useContext(WhiteLabelContext);
